<body class="bg-dark">
    <div class="empty-state-message" 
  [ngStyle]="{
    'background-image': 'linear-gradient(180deg, rgba(0, 0, 0, 0.6), rgba(48, 97, 226, 0.6)), url(assets/img/star.png)',
    'background-size': 'cover',
    'background-position': 'center',
    'background-repeat': 'no-repeat'
  }">
  
  <div class="cover">
    <div class="container">
        <img style="height: 400px;" class="img-fluid mb-10" src="assets/img/404-error.svg" alt="404 Error">
    <h1 class="fw-bold text-white mb-2">Oops! Page not found</h1>
    <p class="mb-4 text-white">
      This page doesn’t exist or was moved. Try going back to our home.
    </p>
    <button routerLink="/" class="btn btn-ib-primary rounded-3 fw-semi">Go to Home</button>
    </div>
  </div>

</div>

</body>